<template>
    <div>
        <div class="container mx-auto">
            <nav
                class="navbar navbar-expand-lg py-2 bg-sib_gray relative flex items-center w-full justify-between mb-10"
            >
                <div class="px-6 grow">
                    <button
                        class="navbar-toggler border-0 py-3 lg:hidden leading-none text-xl bg-transparent text-gray-600 hover:text-gray-700 focus:text-gray-700 transition-shadow duration-150 ease-in-out"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContentX"
                        aria-controls="navbarSupportedContentX"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            class="w-5"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                        >
                            <path
                                fill="currentColor"
                                d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                            ></path>
                        </svg>
                    </button>
                    <div
                        class="navbar-collapse collapse grow items-center"
                        id="navbarSupportedContentX"
                    >
                        <ul class="navbar-nav mr-auto sm:flex flex-row grow">
                            <li class="nav-item dropdown static">
                                <a
                                    class="nav-link pr-2 lg:px-2 py-2 text-gray-600 hover:text-gray-700 focus:text-gray-700 transition duration-150 ease-in-out dropdown-toggle flex items-center whitespace-nowrap no-underline mr-4 appearance-none"
                                    href="#"
                                    data-mdb-ripple="true"
                                    data-mdb-ripple-color="light"
                                    type="button"
                                    id="dropdownMenuButtonX"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    CATEGORY

                                    <div
                                        class="bg-black text-white text-sm rounded-full ml-1 px-1"
                                        :class="
                                            filters.courses.categories.length
                                                ? ''
                                                : 'invisible'
                                        "
                                    >
                                        {{ filters.courses.categories.length }}
                                    </div>

                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="caret-down"
                                        class="w-2 ml-2"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 320 512"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                                        ></path>
                                    </svg>
                                </a>
                                <div
                                    v-on:click.stop=""
                                    class="dropdown-menu w-full lg:w-1/2 mt-0 hidden shadow-lg bg-white xl:absolute left-0 top-full"
                                    aria-labelledby="dropdownMenuButtonX"
                                >
                                    <div class="px-6 lg:px-8 py-5">
                                        <div class="grid lg:grid-cols-2 gap-6">
                                            <div
                                                v-for="option in categories"
                                                :key="option.id"
                                            >
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        v-model="
                                                            filters.courses
                                                                .categories
                                                        "
                                                        :value="option.id"
                                                        @change="getCourses()"
                                                    />
                                                    {{ option.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li class="nav-item dropdown static">
                                <a
                                    class="nav-link pr-2 lg:px-2 py-2 text-gray-600 hover:text-gray-700 focus:text-gray-700 transition duration-150 ease-in-out dropdown-toggle flex items-center whitespace-nowrap no-underline mr-4 appearance-none"
                                    href="#"
                                    data-mdb-ripple="true"
                                    data-mdb-ripple-color="light"
                                    type="button"
                                    id="dropdownMenuButtonX"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    LEVEL

                                    <div
                                        class="bg-black text-white text-sm rounded-full ml-1 px-1"
                                        :class="
                                            filters.courses.level.length
                                                ? ''
                                                : 'invisible'
                                        "
                                    >
                                        {{ filters.courses.level.length }}
                                    </div>
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="caret-down"
                                        class="w-2 ml-2"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 320 512"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                                        ></path>
                                    </svg>
                                </a>
                                <div
                                    v-on:click.stop=""
                                    class="dropdown-menu w-full lg:w-1/2 mt-0 hidden shadow-lg bg-white xl:absolute left-0 top-full"
                                    aria-labelledby="dropdownMenuButtonX"
                                >
                                    <div class="px-6 lg:px-8 py-5">
                                        <div class="grid lg:grid-cols-2 gap-6">
                                            <div
                                                v-for="option in levels"
                                                :key="option"
                                            >
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        v-model="
                                                            filters.courses
                                                                .level
                                                        "
                                                        :value="option"
                                                        @change="getCourses()"
                                                    />
                                                    {{ option }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li
                                v-if="cities && cities.length"
                                class="nav-item dropdown static"
                            >
                                <a
                                    class="nav-link pr-2 lg:px-2 py-2 text-gray-600 hover:text-gray-700 focus:text-gray-700 transition duration-150 ease-in-out dropdown-toggle flex items-center whitespace-nowrap no-underline mr-4 appearance-none"
                                    href="#"
                                    data-mdb-ripple="true"
                                    data-mdb-ripple-color="light"
                                    type="button"
                                    id="dropdownMenuButtonX"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    LOCATION/MODE

                                    <div
                                        class="bg-black text-white text-sm rounded-full ml-1 px-1"
                                        :class="
                                            filters.courses.city.length
                                                ? ''
                                                : 'invisible'
                                        "
                                    >
                                        {{ filters.courses.city.length }}
                                    </div>
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="caret-down"
                                        class="w-2 ml-2"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 320 512"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                                        ></path>
                                    </svg>
                                </a>
                                <div
                                    v-on:click.stop=""
                                    class="dropdown-menu w-full lg:w-1/2 mt-0 hidden shadow-lg bg-white xl:absolute left-0 top-full"
                                    aria-labelledby="dropdownMenuButtonX"
                                >
                                    <div class="px-6 lg:px-8 py-5">
                                        <div class="grid lg:grid-cols-2 gap-6">
                                            <div
                                                v-for="option in cities"
                                                :key="option"
                                            >
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        v-model="
                                                            filters.courses.city
                                                        "
                                                        :value="option"
                                                        @change="getCourses()"
                                                    />
                                                    {{ option }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li
                                v-if="statutes && statutes.length"
                                class="nav-item dropdown static"
                            >
                                <a
                                    class="nav-link pr-2 lg:px-2 py-2 text-gray-600 hover:text-gray-700 focus:text-gray-700 transition duration-150 ease-in-out dropdown-toggle flex items-center whitespace-nowrap no-underline mr-4 appearance-none"
                                    href="#"
                                    data-mdb-ripple="true"
                                    data-mdb-ripple-color="light"
                                    type="button"
                                    id="dropdownMenuButtonX"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    STATUS

                                    <div
                                        class="bg-black text-white text-sm rounded-full ml-1 px-1"
                                        :class="
                                            filters.courses.registration_status
                                                .length
                                                ? ''
                                                : 'invisible'
                                        "
                                    >
                                        {{
                                            filters.courses.registration_status
                                                .length
                                        }}
                                    </div>
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="caret-down"
                                        class="w-2 ml-2"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 320 512"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                                        ></path>
                                    </svg>
                                </a>
                                <div
                                    v-on:click.stop=""
                                    class="dropdown-menu w-full lg:w-1/2 mt-0 hidden shadow-lg bg-white xl:absolute left-0 top-full"
                                    aria-labelledby="dropdownMenuButtonX"
                                >
                                    <div class="px-6 lg:px-8 py-5">
                                        <div class="grid lg:grid-cols-2 gap-6">
                                            <div
                                                v-for="option in statutes"
                                                :key="option.value"
                                            >
                                                <label :class="option.value">
                                                    <input
                                                        type="checkbox"
                                                        v-model="
                                                            filters.courses
                                                                .registration_status
                                                        "
                                                        :value="option.value"
                                                        @change="getCourses()"
                                                    />
                                                    {{ option.text }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div
                            v-if="
                                searchPlaceholder === 'Search course materials'
                            "
                            class="grow mt-3 lg:mt-0 lg:text-center"
                        >
                            SIB course materials in Glittr
                            <br />
                            <a
                                href="https://glittr.org/?search=sib&per_page=25&sort_by=stargazers&sort_direction=desc"
                                ><img
                                    class="h-20 inline-block"
                                    :src="appUrl + '/images/logo-vertical.svg'"
                                    target="_blank"
                                    title="Glittr.org | Git repositories with bioinformatics training material"
                                    alt="Glittr.org | Git repositories with bioinformatics training material"
                            /></a>
                        </div>

                        <div class="mt-8 lg:mt-0">
                            <div class="w-64">
                                <div class="text-2xl font-semibold mb-2">
                                    Stay tuned
                                </div>
                                <div class="mb-2">
                                    <button
                                        type="button"
                                        class="text-sib_blue"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modalLeaveUsEmail"
                                    >
                                        Leave us your email
                                    </button>
                                    to be informed about training activities
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <div class="mb-5">
                <div
                    class="sm:flex justify-between items-center font-bold px-2 sm:px-0"
                >
                    <div class="order-2">
                        <div
                            class="input-group relative flex flex-wrap items-stretch mb-4"
                        >
                            <input
                                type="search"
                                class="relative flex-auto min-w-0 inline-block px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-600 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-gray-800 focus:outline-none border-r-0"
                                :placeholder="searchPlaceholder"
                                aria-label="Search"
                                v-model="filters.name"
                                @input="getCourses()"
                            />
                            <div
                                class="border border-solid border-gray-600 border-l-0 inline-block py-2.5 px-3 text-black font-medium text-sm leading-tight uppercase items-center bg-transparent"
                            >
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="search"
                                    class="w-4"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                    ></path>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div class="text-sib_red order-1">
                        {{ courseTitles.length }} results found

                        <div
                            class="text-sib_red inline-block"
                            v-if="hasFilters"
                            @click="resetFilters()"
                        >
                            <span>-</span>
                            <span class="underline cursor-pointer"
                                >Default filters</span
                            >
                        </div>
                    </div>
                </div>

                <div class="upcoming_courses_table">
                    <div
                        v-for="courseTitle in courseTitles"
                        :key="courseTitle.id"
                        class="row"
                    >
                        <div class="w-20">
                            <img
                                class="w-12 mt-1"
                                :src="appUrl + '/images/course-black.svg'"
                            />
                        </div>

                        <div class="grow 2xl:flex justify-start">
                            <div
                                class="text-left grow lg:max-w-[377px] xl:max-w-[377px] 2xl:max-w-[500px] pr-3 font-cabinet font-semibold"
                            >
                                <a
                                    v-if="courseTitle.courses[0]"
                                    class="no-underline text-2xl"
                                    :target="
                                        courseTitle.courses[0].url
                                            ? '_blank'
                                            : '_self'
                                    "
                                    :href="courseTitle.courses[0].href"
                                >
                                    {{ courseTitle.name }}
                                </a>
                            </div>

                            <div class="2xl:w-[128px] 2xl:px-3">
                                {{ courseTitle.level }}
                            </div>

                            <div class="2xl:w-[248px] 2xl:px-3">
                                <div
                                    v-for="category in courseTitle.categories"
                                    :key="category.id"
                                >
                                    {{ category.name }}
                                </div>
                            </div>
                        </div>

                        <div class="lg:w-[545px] pt-4 lg:pt-0 lg:pl-3">
                            <div class="instances_table">
                                <div
                                    v-for="(
                                        course, index
                                    ) in courseTitle.courses"
                                    :key="course.id"
                                    class="flex flex-wrap w-full mb-8 sm:mb-2"
                                    :class="
                                        index > 2 && !courseTitle.showAllCurses
                                            ? 'hidden'
                                            : ''
                                    "
                                >
                                    <div class="w-52 text-left">
                                        <a
                                            :title="
                                                registration_status_description(
                                                    course.registration_status
                                                )
                                            "
                                            :class="
                                                'transition duration-150 ease-in-out course_instance w-48 ' +
                                                course.registration_status
                                            "
                                            :target="
                                                course.url ? '_blank' : '_self'
                                            "
                                            :href="
                                                course.url
                                                    ? course.url
                                                    : 'course/' + course.code
                                            "
                                        >
                                            {{ course.when }}
                                        </a>
                                    </div>
                                    <div class="w-[158px] sm:pr-3 pt-3">
                                        <div
                                            class="inline-block text-center w-12 -mx-2"
                                        >
                                            <img
                                                v-if="
                                                    'Streamed' === course.city
                                                "
                                                class="w-7 inline"
                                                :src="
                                                    appUrl +
                                                    '/images/streamed.svg'
                                                "
                                            />
                                            <img
                                                v-if="
                                                    'Streamed' !== course.city
                                                "
                                                class="w-5 inline"
                                                :src="
                                                    appUrl +
                                                    '/images/location.svg'
                                                "
                                            />
                                        </div>
                                        {{ course.city }}
                                    </div>

                                    <div class="sm:pt-3">
                                        <div
                                            v-if="course.course_material_url"
                                            class="whitespace-nowrap text-left"
                                        >
                                            <img
                                                class="inline-block w-8 ml-2 mr-1"
                                                :src="
                                                    appUrl +
                                                    '/images/laptop-file-solid.svg'
                                                "
                                            />
                                            <a
                                                :href="
                                                    course.course_material_url
                                                "
                                            >
                                                Course material
                                            </a>
                                        </div>

                                        <div
                                            v-if="
                                                course.city == 'E-Learning' &&
                                                course.number_of_hours
                                            "
                                            class="whitespace-nowrap align-middle text-left inline-block"
                                        >
                                            <img
                                                class="w-7 inline mr-1"
                                                :src="
                                                    appUrl +
                                                    '/images/clock-regular.svg'
                                                "
                                            />
                                            {{ course.number_of_hours }} Hour{{
                                                course.number_of_hours > 1
                                                    ? "s"
                                                    : ""
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- leas us you email modal -->
        <div
            class="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto"
            id="modalLeaveUsEmail"
            tabindex="-1"
            aria-labelledby="modalLeaveUsEmail"
            aria-modal="true"
            role="dialog"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable relative w-auto pointer-events-none"
            >
                <div
                    class="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div
                        class="modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md"
                    >
                        <h5
                            class="text-xl font-medium leading-normal text-gray-800"
                            id="modalLeaveUsEmailLabel"
                        >
                            Leave us your email
                        </h5>
                        <button
                            type="button"
                            class="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body relative p-4">
                        <iframe
                            src="https://www.sib.swiss/form/embed.php?id=51040"
                            style="width: 100%; border: none"
                            scrolling="no"
                            width="100%"
                            height="410"
                            frameborder="0"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const axios = require("axios");

export default {
    props: [
        "appUrl",
        "categories",
        "levels",
        "cities",
        "statutes",
        "defaultFilters",
        "searchPlaceholder",
    ],

    data: () => ({
        filters: {
            name: null,
            courses: {
                categories: [],
                level: [],
                type: [],
                city: [],
                registration_status: [],
                fees: null,
                end_data: null,
            },
        },
        courseTitles: [],
        loading: false,
    }),

    mounted() {
        this.resetFilters();
    },

    computed: {
        hasFilters() {
            return (
                JSON.stringify(this.filters) !==
                JSON.stringify(this.defaultFilters)
            );
        },
    },
    methods: {
        leaveUsEmailClick() {},
        registration_status_description(registration_status) {
            if (!this.statutes) {
                return "";
            }
            let regStatusItem = this.statutes.find(
                (status) => status.value === registration_status
            );
            return regStatusItem
                ? regStatusItem.description
                : registration_status;
        },
        resetFilters() {
            let filters = {
                ...{
                    name: null,
                    courses: {
                        categories: [],
                        level: [],
                        type: [],
                    },
                },
                ...JSON.parse(JSON.stringify(this.defaultFilters)),
            };
            this.filters = filters;
            this.getCourses();
        },

        getCourses() {
            this.locading = true;

            axios({
                url: this.appUrl + "/api/coursetitles",
                method: "GET",
                params: {
                    filters: this.filters,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                },
            })
                .then((response) => {
                    console.log("response", response);
                    this.loading = false;
                    //this.students = [{firstname:'silvano'},{firstname:'vassilios'}]; //response.data.data;
                    let responseData = response.data;
                    this.courseTitles = responseData.records;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
    },
};
</script>
